export const UTM = 'utm'

export const QUEUE_NAME = 'analytics'

export const PUBLISH = 'publish'

export const TRACKING = 'tracking'
